import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const NAV_ITEMS = [
  { id: "dashboard", label: "Dashboard",   icon: "▦", to: "/dashboard" },
  { id: "invoices",  label: "Invoices",    icon: "🗂", to: "/invoices"  },
  { id: "upload",    label: "Upload",      icon: "↑", to: "/upload"    },
  { id: "reports",   label: "GRA Reports", icon: "📋", to: "/reports"   },
  { id: "team",      label: "Team",        icon: "👥", to: "/team"      },
];

const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <aside style={styles.sidebar}>
      <div style={styles.brand}>
        <div style={styles.logoBox}>IA</div>
        <span style={styles.brandName}>InvoiceArk</span>
      </div>

      <nav style={styles.nav}>
        {NAV_ITEMS.filter(item => item.id !== "team" || user?.role === "admin").map(item => {
          const active = location.pathname === item.to;
          return (
            <Link key={item.id} to={item.to} style={{ textDecoration: "none" }}>
              <div style={active ? { ...styles.navItem, ...styles.navActive } : styles.navItem}>
                <span style={styles.navIcon}>{item.icon}</span>
                <span>{item.label}</span>
              </div>
            </Link>
          );
        })}
      </nav>

      <div style={styles.sidebarBottom}>
        <div style={styles.userBox}>
          <div style={styles.avatar}>{user?.name?.[0] || "U"}</div>
          <div>
            <div style={styles.userName}>{user?.name || "User"}</div>
            <div style={styles.userRole}>{user?.role || "admin"}</div>
          </div>
        </div>
        <button onClick={logout} style={styles.logoutBtn}>Sign out</button>
      </div>
    </aside>
  );
};

const styles = {
  sidebar: { width: "220px", background: "#0a0f1e", display: "flex", flexDirection: "column", padding: "24px 16px", flexShrink: 0, minHeight: "100vh" },
  brand: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "36px", paddingLeft: "8px" },
  logoBox: { width: "32px", height: "32px", background: "#f6ad55", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "12px", color: "#0a0f1e" },
  brandName: { color: "#fff", fontWeight: "bold", fontSize: "15px", letterSpacing: "0.5px" },
  nav: { display: "flex", flexDirection: "column", gap: "4px", flex: 1 },
  navItem: { display: "flex", alignItems: "center", gap: "10px", padding: "10px 12px", borderRadius: "8px", color: "#718096", fontSize: "14px", cursor: "pointer", transition: "all 0.15s" },
  navActive: { background: "#1e2a3a", color: "#fff" },
  navIcon: { fontSize: "14px", width: "18px", textAlign: "center" },
  sidebarBottom: { borderTop: "1px solid #1e2a3a", paddingTop: "16px", display: "flex", flexDirection: "column", gap: "12px" },
  userBox: { display: "flex", alignItems: "center", gap: "10px" },
  avatar: { width: "32px", height: "32px", borderRadius: "50%", background: "#f6ad55", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "13px", color: "#0a0f1e", flexShrink: 0 },
  userName: { color: "#e2e8f0", fontSize: "13px", fontWeight: "600" },
  userRole: { color: "#718096", fontSize: "11px", textTransform: "capitalize" },
  logoutBtn: { background: "transparent", border: "1px solid #2d3748", color: "#718096", borderRadius: "6px", padding: "7px 12px", fontSize: "12px", cursor: "pointer", textAlign: "left" },
};

export default Sidebar;